import styled from "styled-components";

export const LastUpdatedAt = styled.div`
  text-align: end;
  font-size: 12px;
`;